import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Reconstruire l'écran quand les PARAMÈTRES de sa route changent.
 *
 * Par défaut, Angular garde le composant tant que la définition de route est la
 * même : aller d'un bail à un autre (`details-lease/A` → `details-lease/B`)
 * change l'URL mais laisse la fiche de A à l'écran. Presque toutes les fiches
 * du dépôt lisent leur id UNE fois, dans `ngOnInit`, sur `route.snapshot` —
 * le défaut était donc latent partout, et la palette du graphe (qui va
 * volontiers d'un bail à son voisin) l'a rendu visible le 2026-09-25.
 *
 * Une règle ici plutôt qu'un abonnement à `paramMap` dans chaque fiche : une
 * fiche est un gros composant à état (onglets chargés, formulaires, signaux),
 * et la remettre à zéro à la main est exactement ce qu'on oublierait d'y
 * faire. Le reconstruire garantit un état propre.
 *
 * Les paramètres de REQUÊTE n'entrent pas dans la règle : `?tab=` et les
 * filtres changent sur place, sans recharger l'écran — comme avant.
 */
@Injectable()
export class ParamAwareRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig && sameParams(future.params, curr.params);
  }
}

function sameParams(a: Record<string, unknown>, b: Record<string, unknown>): boolean {
  const keys = Object.keys(a);
  return keys.length === Object.keys(b).length && keys.every(k => a[k] === b[k]);
}
